import React, { useRef, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { dismiss } from 'redux/slices/notification';
import { ERROR, SUCCESS } from 'redux/slices/notification/types';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as CrossIcon } from 'assets/icons/times.svg';
import { notification as TEXT } from 'locales/en';
import './style.css';

const Notification = ({ className }) => {
  const dismissTimeout = useRef();
  const dispatch = useDispatch();
  const { isVisible, type, message, timeout } = useSelector(
    (state) => state.notification
  );
  const isCollapsed = useSelector((state) => state.sidebar.isCollapsed);

  const wrapperClassName = useMemo(() => {
    if (isCollapsed) {
      return 'collapsed';
    } else {
      return 'uncollapsed';
    }
  }, [isCollapsed]);

  useEffect(() => {
    if (timeout) {
      if (isVisible) {
        dismissTimeout.current = setTimeout(() => {
          dispatch(dismiss());
        }, timeout);
      }
      if (!!dismissTimeout.current && !isVisible) {
        clearTimeout(dismissTimeout.current);
      }
      return () => clearTimeout(dismissTimeout.current);
    }
  }, [dispatch, isVisible, timeout]);

  return isVisible ? (
    <div
      className={`z-50 ${
        type === SUCCESS ? 'bg-brand-primary' : 'bg-red-500'
      } px-5 py-4 rounded shadow-lg text-white flex items-center justify-between left-0 right-0 mr-auto duration-1000 animate-slidedown ${wrapperClassName} ${className}`}
    >
      <div className="mr-2 flex items-center flex-1 w-full text-white">
        <div className="w-4">
          {type === SUCCESS && <CheckIcon className="fill-current w-6 h-4" />}
          {type === ERROR && <CrossIcon className="fill-current w-4 h-4" />}
        </div>
        <p className="text-sm ml-3 text-left">{message}</p>
      </div>
      <button
        className="border-0 text-opacity-40 text-sm focus:outline-none text-right underline"
        onClick={() => dispatch(dismiss())}
      >
        {TEXT.dismiss}
      </button>
    </div>
  ) : null;
};

Notification.propTypes = {
  className: PropTypes.string,
};
Notification.defaultProps = {
  className: 'dashboard-notification fixed top-12',
};
export default Notification;
